import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const FleetView = lazy(async () => {
  const m = await import("@/features/fleet/components/fleet-view");
  return { default: m.FleetView };
});

export const fleetRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/fleet",
  component: () => (
    <Suspense fallback={null}>
      <FleetView />
    </Suspense>
  ),
});
